import { render, staticRenderFns } from "./BaseColorSelectedField.vue?vue&type=template&id=1d5f4d70&scoped=true"
import script from "./BaseColorSelectedField.vue?vue&type=script&lang=js"
export * from "./BaseColorSelectedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f4d70",
  null
  
)

export default component.exports